import React, { Component } from 'react';
import { observer, inject } from "mobx-react";
import { withRouter, NavLink } from "react-router-dom";
import Header from './Header';
import Porfolio from './Porfolio';
let store = null;
var self = null;
@inject("appStore")
@observer
class AboutMe extends React.Component {

    constructor(props) {
        super(props);
    }


    render() {
        return (
            <section class="o-section  t-section  ">

                <div class="o-section__header-bg  t-section__header"></div>
                <div class="o-section__content-bg  t-section__content"></div>

                <div class="o-container">
                    <div class="o-section__container">

                        <header class="o-section__header  t-section__header">
                            <div class="o-content">
                                <h2 class="o-section__heading">
                                    Intro
                                </h2>
                                <div class="o-content__body  o-section__description">
                                    What I am all about.
                                </div>
                            </div>
                        </header>

                        <div class="o-section__content  t-section__content  ">
                            
                            <div class="o-content">
                                <div class="c-intro">
                                    <div class="o-content__body">
                                        <p>
                                        Hi, myself Shoubhik Banerjee, Senior IT Expert specializing in AWS cloud infrastructure, generative AI, and intelligent automation, with hands-on experience designing and operating enterprise-scale AWS environments. Strong background in building secure, scalable, and governed cloud platforms aligned with organizational and compliance requirements.
                                            {/* <a href="#" target="_blank">pretium</a>, ligula sollicitudin laoreet viverra, tortor libero sodales leo, eget blandit nunc tortor eu nibh. Nullam mollis. Ut justo. Suspendisse potenti. Nulla vitae mauris non felis mollis faucibus. */}
                                        </p>
                                        <p>
                                        Currently contributing at Volkswagen Group Technology Solutions India (VWITS), where I work on delivering AWS Landing Zones, multi-account architectures, Service Control Policies (SCPs), and secure cloud foundations. My role focuses on enabling teams with reliable cloud infrastructure while maintaining governance, security, and operational excellence.
                                        </p>
                                        <p>
I have proven experience developing AI-powered solutions, including AWS Bedrock–based chatbots and NLP-driven systems, as well as event-driven serverless applications using AWS Lambda, Step Functions, SQS, SNS, and DynamoDB to support scalable and automated workflows.                                     
                                        </p>
                                        <p>
I bring strong end-to-end delivery capabilities with hands-on expertise in Node.js, React.js, and Python, bridging cloud architecture, backend services, and user-facing applications to deliver production-ready, business-aligned solutions.                                       
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>

            </section>

        );
    }
}

export default withRouter(AboutMe);